// extracted by css-extract-rspack-plugin
export default {"styledGroupHeaderWrapper":"styled-group-header-module__styledGroupHeaderWrapper__K6zQQ3Z"};